import { useQuery } from '@tanstack/react-query';
import { supabase } from '../services/supabase';

export interface VolunteerOpportunity {
  id: string;
  title: string;
  description?: string;
  category?: string;
  location?: string;
  time_commitment?: string;
  thumbnail?: string;
  notification_group_id?: string | null;
  created_at?: string;
}

export const useVolunteerOpportunities = () => {
  return useQuery<VolunteerOpportunity[]>({
    queryKey: ['volunteerOpportunities'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('volunteer_opportunities')
        .select('id, title, description, category, location, time_commitment, thumbnail, notification_group_id, created_at')
        .order('created_at', { ascending: false })
        .limit(200);
      if (error) throw error;
      return data as VolunteerOpportunity[];
    },
    staleTime: 5 * 60_000,
  });
};
